module.exports = __webpack_public_path__ + "static/media/user-home.3f31ee75.png";